exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ic_rule{width:7.173333rem;box-shadow:0 .026667rem .186667rem 0 rgba(0,0,0,.1)!important;border-radius:.213333rem!important;font-size:.24rem;line-height:.426667rem;color:#333;padding:.266667rem .666667rem .4rem .4rem}", ""]);

// exports
